import React, { Component } from 'react'
import Quill from 'quill'
import { connect } from 'react-redux'
import Actions from '@actions'
import { Loader } from '@components/UI'

class Note extends Component {
  constructor(props) {
    super(props)
    this.state = { loading: false }
  }

  componentDidMount() {
    if (this.props.file.id) this.load()
    else this.init(this.props.file.data)
  }

  load = () =>
    this.setState({ loading: true }, () => {
      const stop = () => this.setState({ loading: false })

      this.props.loadFile(
        (file) => {
          this.init(file.data)
          stop()
        },
        stop,
        this.props.file.id
      )
    })

  init = (data) => {
    this.editor = new Quill('#note-container')
    this.editor.disable()
    this.editor.setContents(data)
  }

  render() {
    return (
      <div className='note-block gp-note'>
        <div className='viewer-wrapper'>
          <div id='note-container' />
        </div>
        {this.state.loading && <Loader full icon />}
      </div>
    )
  }
}

const mapActionsToProps = {
  loadFile: Actions.loadFile
}

export default connect(() => ({}), mapActionsToProps)(Note)
